import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { SELECTED_BORDER } from 'src/config/styles'
import customColors from 'src/config/colorsV2'
import { Theme } from '@mui/material/styles'

const selectedStyles = (theme: Theme) => ({
  content: '""',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  boxSizing: 'border-box',
  border: SELECTED_BORDER(theme),
})

const selectedBordeRadiusStyles = {
  ...selectedStyles,
  borderRadius: 8,
}

export default createUseStyles({
  root: {
    backgroundColor: customColors.white,
    boxShadow: '0px 1px 2px rgba(33, 33, 33, 0.1)',
    width: '100%',
    borderRadius: 8,
    [forPhoneOnly]: {
      '&$noRadius': {
        borderRadius: 0,
      },
    },
  },
  isSelected: {
    position: 'relative',
    '&::after': {
      ...selectedBordeRadiusStyles,
    },

    [forPhoneOnly]: {
      '&$noRadius': {
        '&::after': {
          borderRadius: 0,
        },
      },
    },
  },
  isDesktop: {
    width: 'fit-content',
  },
  clickable: {
    cursor: 'pointer',
  },
  noRadius: {},
})
